document.addEventListener('DOMContentLoaded', function () {
  // Target the specific featured media ID
  const featuredMediaId = '28484424597658'; // slider1.webp

  function resetToFeatured() {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;
    const sectionId = mediaGallery.dataset.section;
    if (mediaGallery.setActiveMedia) {
      mediaGallery.setActiveMedia(`${sectionId}--${featuredMediaId}`, false);
    }
  }

  // Try multiple times to catch Dawn's deferred init
  setTimeout(resetToFeatured, 100);
  setTimeout(resetToFeatured, 300);
  setTimeout(resetToFeatured, 600);
});
